/* global $, data, league, query_string */
/* eslint-disable import/no-extraneous-dependencies */
import Table from 'bam-node-savant-table/table'

import { threeDigitFormat, toFixed } from '../utils'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'expected_stats'

// function addPlusSign(val) {
//     return val > 0 ? `+${toFixed(3)(val)}` : toFixed(3)(val)
// }
// not yet
function addPlusSign(val) {
    return toFixed(3)(val)
}

$(document).ready(() => {
    $('form').submit(false)
    $('#ddlTeam').change(() => {
        $('#lblTeam').html($('#ddlTeam option:selected').text())
    })
    $('#ddlPosition').change(() => {
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })
    $('#ddlFilter').change(() => {
        $('#lblFilter').html($('#ddlFilter').val())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(
            `${$('#ddlFilter option:selected').text()} (${$(
                '#ddlMin option:selected'
            ).text()})`
        )
    })
    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })

    if (query_string.type) {
        if (query_string.type.indexOf('team') > -1) {
            $('#team-ddl').hide()
        }
        $('#ddlType').val(query_string.type).attr('selected', true)
        $('#lblType').html($('#ddlType option:selected').text())
    }
    if (query_string.filterType) {
        $('#ddlFilter').val(query_string.filterType).attr('selected', true)
        $('#lblFilter').html($('#ddlFilter option:selected').val())
    }
    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(
            `${$('#ddlFilter option:selected').text()} (${$(
                '#ddlMin option:selected'
            ).text()})`
        )
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (query_string.position) {
        $('#ddlPosition').val(query_string.position).attr('selected', true)
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    }

    if (query_string.team) {
        $('#ddlTeam').val(query_string.team).attr('selected', true)
        $('#lblTeam').html($('#ddlTeam option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    let secondaryHeaders
    const width = $(`#${tableDivId}`).outerWidth()
    let repeatHeaders = false
    if (width <= 768) {
        repeatHeaders = 15
    }

    if (league && data.length > 0) {
        const headers = [
            {
                name: '',
                field: 'name',
                headerClass: 'th-component-header table-static-column',
                fieldClass: 'tr-data table-static-column',
            },
            {
                name: 'Year',
                field: 'year',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'BA&nbsp;&nbsp;&nbsp;&nbsp;',
                field: 'ba',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: threeDigitFormat,
            },
            {
                name: 'xBA&nbsp;&nbsp;&nbsp;&nbsp;',
                field: 'est_ba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: threeDigitFormat,
            },
            {
                name: 'Diff',
                field: 'est_ba_minus_ba_diff',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: addPlusSign,
            },
            {
                name: 'SLG',
                field: 'slg',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: threeDigitFormat,
            },
            {
                name: 'xSLG',
                field: 'est_slg',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: threeDigitFormat,
            },
            {
                name: 'Diff',
                field: 'est_slg_minus_slg_diff',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: addPlusSign,
            },
            {
                name: 'wOBA',
                field: 'woba',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: threeDigitFormat,
            },
            {
                name: 'xwOBA',
                field: 'est_woba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: threeDigitFormat,
            },
            {
                name: 'Diff',
                field: 'est_woba_minus_woba_diff',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                displayFn: addPlusSign,
            },
        ]

        secondaryHeaders = [
            {
                name: '',
                colspan: 2,
                headerClass: 'th-name-header',
            },
            {
                name: 'Batting Avg',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: 'Slugging',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: 'Quality of Contact + K + BB',
                colspan: 3,
                headerClass: 'th-title-header',
            },
        ]

        /* eslint-disable no-new */
        new Table({
            id: 'league_average',
            repeatHeader: repeatHeaders,
            secondaryHeaders,
            headers,
            data: league,
        })
    }

    if (data && data.length > 0) {
        const dataLoad = data

        const headers = [
            {
                name: 'Team',
                field: 'entity_team_name_alt',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data align-center',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'entity_team_id',
                photoOnly: true,
            },
            /* {
                name: 'Age',
                field: 'age',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data'
            }, */
            {
                name: 'PA',
                field: 'pa',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'BIP',
                field: 'bip',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'BA&nbsp;&nbsp;&nbsp;&nbsp;',
                field: 'ba',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: threeDigitFormat,
            },
            {
                name: 'xBA&nbsp;&nbsp;&nbsp;&nbsp;',
                field: 'est_ba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: threeDigitFormat,
            },
            {
                name: 'Diff',
                field: 'est_ba_minus_ba_diff',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: addPlusSign,
            },
            {
                name: 'SLG',
                field: 'slg',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: threeDigitFormat,
            },
            {
                name: 'xSLG',
                field: 'est_slg',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: threeDigitFormat,
            },
            {
                name: 'Diff',
                field: 'est_slg_minus_slg_diff',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: addPlusSign,
            },
            {
                name: 'wOBA',
                field: 'woba',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: threeDigitFormat,
            },
            {
                name: 'xwOBA',
                field: 'est_woba',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: threeDigitFormat,
                highlight:
                    query_string.type &&
                    query_string.type.indexOf('pitcher') > -1
                        ? [0.45, 0.35, 0.15]
                        : [0.15, 0.35, 0.45],
            },
            {
                name: 'Diff',
                field: 'est_woba_minus_woba_diff',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                displayFn: addPlusSign,
            },
        ]

        let secondaryColSpan = 5
        const isBatterType = $('#ddlType').val().includes('batter')
        if ($('#ddlType').val() === 'batter') {
            $('#positionGroup').show()
            secondaryColSpan = 6
            headers.splice(2, 0, {
                name: 'Pos',
                field: 'pos_group',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            })
            headers.splice(0, 0, {
                name: 'Player',
                field: 'href',
                customSortField: 'player_name_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'entity_id',
            })
        } else if ($('#ddlType').val() === 'pitcher') {
            headers.splice(0, 0, {
                name: 'Player',
                field: 'href',
                customSortField: 'player_name_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'entity_id',
            })
        } else {
            secondaryColSpan = 4
            headers[0].headerClass += ' table-static-column'
            headers[0].fieldClass += ' table-static-column'
            $('#ddlPosition').hide()
            $('#ddlMinPA').hide()
            headers[0].photoOnly = false
        }

        secondaryHeaders = [
            {
                name: '',
                colspan: secondaryColSpan,
                headerClass: 'th-name-header',
            },
            {
                name: 'Batting Avg',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: 'Slugging',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: 'Quality of Contact + K + BB',
                colspan: 3,
                headerClass: 'th-title-header',
            },
        ]

        if ($('#ddlType').val() === 'pitcher') {
            secondaryHeaders.push({
                name: 'ERA',
                colspan: 3,
                headerClass: 'th-title-header',
            })
            headers.push({
                name: 'ERA',
                field: 'era',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                displayFn: toFixed(2),
            })
            headers.push({
                name: 'xERA',
                field: 'xera',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: toFixed(2),
            })
            headers.push({
                name: 'Diff',
                field: 'era_minus_xera_diff',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
                displayFn: toFixed(2),
            })
        }

        /* eslint-disable no-new */
        new Table({
            id: 'expected_stats',
            secondaryHeaders,
            headers,
            data: dataLoad,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            // TODO:
            defaultSortDirection: isBatterType ? 'desc' : 'asc',
            initialSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            sortCallback(_, id, header) {
                $('#sortDir').val(header.state)
                $('#sort').val(id)
                populateUrl()
            },
            repeatHeader: repeatHeaders,
            showRank: true,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/expected_statistics?type=${$(
            '#ddlType'
        ).val()}&year=${$('#ddlSeason').val()}&position=${$(
            '#ddlPosition'
        ).val()}&team=${$('#ddlTeam').val()}&filterType=${$(
            '#ddlFilter'
        ).val()}&min=${$('#ddlMin').val()}`
    })

    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/expected_statistics?type=${$(
            '#ddlType'
        ).val()}&year=${$('#ddlSeason').val()}&position=${$(
            '#ddlPosition'
        ).val()}&team=${$('#ddlTeam').val()}&filterType=${$(
            '#ddlFilter'
        ).val()}&min=${$('#ddlMin').val()}&csv=true`
    })
})

window.addEventListener('scroll', () => {
    if (!ticking && data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId)
            ticking = false
        })

        ticking = true
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (width && width > 767) {
        // console.log(width);
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $(`#${divId} table tbody .default-table-row`)
            .first()
            .children('td')
            .each(function eachHandler() {
                const rowWidth = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    rowWidth
                )
                tableCell += 1
            })

        $(`#${divId} table thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $(`#${divId} table thead .tr-component-row`)
            .children('th')
            .each(function eachHandler() {
                const rowWidth = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    rowWidth
                )
                tableCell += 1
            })
    }
}

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})

function populateUrl() {
    const url = `/leaderboard/expected_statistics?type=${$(
        '#ddlType'
    ).val()}&year=${$('#ddlSeason').val()}&position=${$(
        '#ddlPosition'
    ).val()}&team=${$('#ddlTeam').val()}&filterType=${$(
        '#ddlFilter'
    ).val()}&min=${$('#ddlMin').val()}&sort=${$('#sort').val()}&sortDir=${$(
        '#sortDir'
    ).val()}`
    window.history.pushState('', '', url)
    return url
}
